import { create } from "zustand";

const useLayoutStore = create((set) => ({
  // desktop (permanent sidebar)
  isSidebarOpen: true,
  setSidebarOpen: (open) => set({ isSidebarOpen: open }),
  toggleSidebar: () => set((s) => ({ isSidebarOpen: !s.isSidebarOpen })),

  // mobile & tablet (temporary drawer)
  mobileSidebarOpen: false,
  setMobileSidebarOpen: (open) => set({ mobileSidebarOpen: open }),
  toggleMobileSidebar: () => set((s) => ({ mobileSidebarOpen: !s.mobileSidebarOpen })),

  // optional: lưu loại thiết bị
  deviceType: "desktop", // "mobile" | "tablet" | "laptop" | "desktop" | "large"
  setDeviceType: (type) => set({ deviceType: type }),
}));

export default useLayoutStore;
